<template>
  <v-app-bar
    class="print-display-none"
    v-bind:class="[isValis ? 'header-color-valis' : isCpmMode? 'header-color-cpm-rakuten' : 'header-color']"
    dark
    app
  >
    <v-app-bar-title class="d-flex flex-grow-0 flex-shrink-0 pa-0 header-title-custom">
      <router-link to="/" class="logo-link">
        <img :src="image_src" class="logo-image" />
      </router-link>
    </v-app-bar-title>
    <v-toolbar-items v-if="isLogin" class="hidden-sm-and-down">
      <v-btn v-if="isViewHeader && isRoleSuper" variant="text" @click="agencyList" color="blue-lighten-5">
        <v-icon>mdi-home</v-icon>
        {{ $t('commons.global.menu.agencyList') }}
      </v-btn>
      <v-btn v-if="isViewHeader && isRoleSuper" variant="text" @click="superAdvertiserList" color="blue-lighten-5">
        <v-icon>mdi-text-long</v-icon>
        {{ $t('commons.global.menu.advertiserList') }}
      </v-btn>
      <v-btn v-if="isRoleAgency" variant="text" @click="advertiserList" color="blue-lighten-5">
        <v-icon>mdi-home</v-icon>
        {{ $t('commons.global.menu.advertiserList') }}
      </v-btn>
    </v-toolbar-items>
    <v-spacer></v-spacer>
    <v-toolbar-items v-if="isLogin" class="hidden-sm-and-down">
      <div class="email-label" style="color: #E3F2FD;">{{ user }}</div>
      <v-btn v-if="isLogin" variant="text" @click="logout" color="blue-lighten-5">
        <v-icon>mdi-logout</v-icon>
        {{ $t('commons.global.menu.logout') }}
      </v-btn>
    </v-toolbar-items>
    <v-toolbar-items v-if="isLogin" class="hidden-md-and-up">
      <v-menu>
        <template v-slot:activator="{ props }">
          <v-btn icon v-bind="props" color="blue-lighten-5">
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-if="isViewHeader && isRoleSuper" @click="agencyList"> 
            <v-list-item-title>{{ $t('commons.global.menu.agencyList') }}</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="isViewHeader && isRoleSuper" @click="superAdvertiserList">
            <v-list-item-title>{{ $t('commons.global.menu.advertiserList') }}</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="isRoleAgency" @click="advertiserList">
            <v-list-item-title>{{ $t('commons.global.menu.advertiserList') }}</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>{{ user }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-title>{{ $t('commons.global.menu.logout') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-app-bar>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'headerVue',
  props: ['agencyId', 'advertiserId'],
  data: function() {
    return {
      isValis: false,
      isCpmMode: false,
      image_src: require(`../../../public/imgs/${process.env.ProjectCode}/logo.png`)
    }
  },
  methods: {
    ...mapGetters('headerParam', ['getHeaderAgencyId', 'getHeaderAdvertiserId']),
    ...mapActions('headerParam', ['setHeaderParamAgencyAdvertiser']),
    logout: function() {
      this.$router.replace('/logout').catch(err => {
        console.error('Router navigation error:', err);
        if (!err.message.includes('Redirected when going from')) {
          throw err
        }
      })
    },
    agencyList: function() {
      this.$router.push('/agencyList')
    },
    superAdvertiserList: function() {
      var agencyId = isNumber(this.getHeaderAgencyId()) ? this.getHeaderAgencyId() : '0'
      // VueRouter 側から ConsoleError が発生するので、広告主一覧ページからのボタン押しはスルーする
      if (this.$route.name !== 'AdvertiserList') {
        this.$router.push('/advertiserList/' + agencyId)
      }
    },
    advertiserList: function() {
      var userMap = this.$store.getters['auth/userMap']
      var agencyId = isNumber(userMap['custom:agencyId']) ? userMap['custom:agencyId'] : '0'
      // VueRouter 側から ConsoleError が発生するので、広告主一覧ページからのボタン押しはスルーする
      if (this.$route.name !== 'AdvertiserList') {
        this.$router.push('/advertiserList/' + agencyId)
      }
    },
    campaignPeriodList: function() {
      var userMap = this.$store.getters['auth/userMap']
      var agencyId = isNumber(userMap['custom:agencyId']) ? userMap['custom:agencyId'] : '0'
      var advertiserId = isNumber(userMap['custom:advertiserId']) ? userMap['custom:advertiserId'] : '0'
      this.$router.push('/campaignPeriodList/' + agencyId + '/' + advertiserId)
    },
    digestive: function() {
      var agencyId = isNumber(this.getHeaderAgencyId()) ? this.getHeaderAgencyId() : '0'
      var advertiserId = isNumber(this.getHeaderAdvertiserId()) ? this.getHeaderAdvertiserId() : '0'
      this.$router.push('/digestive/' + agencyId + '/' + advertiserId)
    },
    onResize: function() {
      if (window.innerWidth < 960) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    }
  },
  computed: {
    isLogin: function() {
      return this.$store.getters['auth/isLogined']
    },
    user: function() {
      return this.$store.getters['auth/userName']
    },
    isViewHeader: function() {
      if (this.$route.name === 'AgencyList' || this.$route.name === 'LoginRouteBranch') {
        return false
      } else {
        return true
      }
    },
    isRoleSuper: function() {
      return this.$store.getters['auth/isRoleSuper']
    },
    isRoleAgency: function() {
      return this.$store.getters['auth/isRoleAgency']
    },
    isRoleAdvertiser: function() {
      return this.$store.getters['auth/isRoleAdvertiser']
    }
  },
  mounted: function() {
    if (process.env.ProjectCode === '301') {
      this.isValis = true
    }
    if (process.env.ProjectCode === '111') {
      this.isCpmMode = true
    }
  }
}
const isNumber = function(value) {
  if (typeof value !== 'number' && typeof value !== 'string') return false
  else return typeof parseFloat(value) === 'number' && isFinite(value)
}
</script>
<style scoped>
.logo-image {
  height: 46px;
  vertical-align: middle;
}
@media screen and (min-width: 960px) {
  .logo-image {
    height: 62px;
    vertical-align: middle;
  }
}
.header-color {
  background-color: #4b7001 !important;
}
.header-color-valis {
  background-color: #093493 !important;
}
.header-color-cpm-rakuten {
  background-color: #BF0000 !important;
}
.email-label {
  margin-top: 22px;
  font-size: 14px;
}
.v-toolbar-title {
  flex: 0 0 auto;
}
.v-app-bar-title.header-title-custom {
  padding-left: 0px !important; 
  padding-right: 0px !important; 
  min-width: 0 !important;
}
.v-list-item[tabindex]:not([tabindex="-1"]) {
  color: #1976D2;
}
.v-app-bar-title .logo-link {
  display: flex;
  align-items: center;
  height: 100%;
  flex-shrink: 1;
  flex-basis: auto;
  overflow: hidden;
}

@media print {
  .print-display-none {
    display: none;
  }
}
</style>
